import type { psAxiosInstance } from '@patsnap/common-ps-http';
import psHttp from '@patsnap/common-ps-http';
let defPsHttp:psAxiosInstance['psHttp'] = psHttp;

export function setPsHttp(o:psAxiosInstance['psHttp']) {
    defPsHttp = o;
}

export async function enableLocalDevTokenbase() {
    const { prepareTokenBase } = await import('./enable-token-base');
    await prepareTokenBase();
}

export default function getPsHttp():typeof psHttp {
    return defPsHttp;
}
